<script>
  import Q01 from './Q01.svelte';
  import Q02 from './Q02.svelte';
  import Q03 from './Q03.svelte';
  import Q04 from './Q04.svelte';
  import Q05 from './Q05.svelte';
  import Q06 from './Q06.svelte';
  import Q07 from './Q07.svelte';
  import Q08 from './Q08.svelte';
  import Q09 from './Q09.svelte';
  import Q10 from './Q10.svelte';
  import Q11 from './Q11.svelte';
  import Q12 from './Q12.svelte';

  const questions = [Q01, Q02, Q03, Q04, Q05, Q06, Q07, Q08, Q09, Q10, Q11, Q12];

  export let currentIndex = 0;
</script>

<section class="q-container">
  {#each questions as q, index}
    <div class="q-wrapper" class:q-hidden={index !== currentIndex}>
      <svelte:component this={q} />
    </div>
  {/each}
</section>

<style>
  .q-container {
    display: grid;
    grid-template: 'main';
  }
  .q-wrapper {
    grid-area: main;
    transition: all 1s;
  }
  .q-hidden {
    display: none;
    opacity: 0;
    transition: all 0s;
  }
  @media (min-width: 768px) {
    .q-hidden {
      display: block;
      visibility: hidden;
    }
  }
</style>
